import React, { useEffect, useState } from "react";
import { getDashboardTransactions } from "../api/authApi";
import { useAuth } from "../context/AuthContext";

function formatDate(ts) {
  return new Date(ts * 1000).toLocaleString();
}

export default function DashboardPage() {
  const { user, loading: authLoading } = useAuth();
  const [txs, setTxs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || authLoading) return;
    setLoading(true);
    getDashboardTransactions()
      .then(res => {
        setTxs(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [user, authLoading]);

  if (loading || authLoading) return <div>Loading…</div>;
  if (!user) return <div>Please log in.</div>;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Transaction Dashboard</h2>
      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">Charge ID</th>
              <th className="px-4 py-2 text-left">Amount</th>
              <th className="px-4 py-2 text-left">Currency</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Created</th>
              <th className="px-4 py-2 text-left">Outcome</th>
              <th className="px-4 py-2 text-left">Reason</th>
              <th className="px-4 py-2 text-left">Risk Level & Score</th>
              <th className="px-4 py-2 text-left">Blocked By</th>
            </tr>
          </thead>
          <tbody>
            {txs.map(tx => (
              <tr key={tx.id} className="border-b last:border-b-0">
                <td className="px-4 py-2 font-mono">{tx.id}</td>
                <td className="px-4 py-2">{tx.amount.toFixed(2)}</td>
                <td className="px-4 py-2">{tx.currency?.toUpperCase()}</td>
                <td className="px-4 py-2">{tx.email}</td>
                <td className="px-4 py-2">{formatDate(tx.created)}</td>
                <td className="px-4 py-2">
                  <span className={
                    tx.outcome === "failed" || tx.outcome === "blocked"
                      ? "bg-red-100 text-red-700 px-2 py-1 rounded"
                      : tx.outcome === "succeeded" || tx.outcome === "authorized"
                      ? "bg-green-100 text-green-700 px-2 py-1 rounded"
                      : "bg-gray-100 text-gray-700 px-2 py-1 rounded"
                  }>
                    {tx.outcome}
                  </span>
                </td>
                <td className="px-4 py-2">{tx.reason || <span className="text-gray-400">—</span>}</td>
                <td className="px-4 py-2">
                  {tx.outcome_risk_level ? (
                    <span
                      className={
                        tx.outcome_risk_level === "highest"
                          ? "bg-red-200 text-red-800 px-2 py-1 rounded"
                          : tx.outcome_risk_level === "elevated"
                          ? "bg-yellow-100 text-yellow-800 px-2 py-1 rounded"
                          : "bg-green-100 text-green-800 px-2 py-1 rounded"
                      }
                    >
                      {tx.outcome_risk_level}
                    </span>
                  ) : (
                    "-"
                  )}
                  {tx.outcome_risk_level && typeof tx.outcome_risk_score === "number" ? " - " : " "}
                  {typeof tx.outcome_risk_score === "number" ? tx.outcome_risk_score : (tx.outcome_risk_level ? "" : "-")}
                </td>
                <td className="px-4 py-2">
                  {tx.blocked_by === "Stripe" && (
                    <span className="">Stripe</span>
                  )}
                  {tx.blocked_by === "Custom Rule" && (
                    <span className="">Custom Rule</span>
                  )}
                  {!tx.blocked_by && (
                    <span className="text-gray-400">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {txs.length === 0 && <div className="p-4 text-gray-500">No transactions found.</div>}
      </div>
    </div>
  );
}